import { useMemo } from "react";
import useCurrentUser from "../../../hooks/useCurrentUser";
import useFinancialsConfiguration from "../../../hooks/useFinancialsConfiguration";
import { routeConfig } from "../../../routes";

const useRouteSwitch = () => {
  const { data: currentUser } = useCurrentUser();
  const { data: financialsConfiguration } = useFinancialsConfiguration();

  const routeList = useMemo(() => {
    const list = routeConfig(currentUser, financialsConfiguration?.financials);
    return list;
  }, [currentUser, financialsConfiguration?.financials]);

  return { routeList, currentUser };
};

export default useRouteSwitch;
